import { createRouter, createWebHistory, RouteRecordRaw, NavigationGuard } from 'vue-router';
import Layout from '../components/Layout.vue';
import Followed from '../views/Followed.vue';
import Participant from '../views/Participant.vue';
import Notfound from '../views/Notfound.vue';
import authRouter from '../nmb/oauth2-mobile-wx/routes/index';
import TaskMessage from '../views/TaskMessage.vue';
import rely from '../nmb/oauth2-mobile-wx/oauth2rely';

const Login: NavigationGuard = (to, from, next) => {
    rely.checkLogin(to, next);
    next();
};

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        beforeEnter: Login,
        component: Layout,
        redirect: 'index',
        children: [
            {
                path: 'index',
                component: () => import('@/views/Home.vue'),
                meta: {
                    index: 1, // 页面层级，用于判断页面过度时，滑动方向的
                    title: '日历',
                },
            },
            {
                path: 'event',
                name: 'event',
                component: () => import('@/views/event/index.vue'),
                meta: {
                    index: 2,
                    keepAlive: true,
                },
            },
            {
                path: 'event/member',
                name: 'member',
                component: () => import('@/views/event/edit/member.vue'),
                meta: {
                    index: 3,
                    title: '添加参与人',
                    keepAlive: true,
                },
            },
            {
                path: 'event/memberList',
                name: 'memberList',
                component: () => import('@/views/event/edit/memberList.vue'),
                meta: {
                    index: 3,
                    title: '参与人',
                    keepAlive: true,
                },
            },
            {
                path: 'event/meeting',
                name: 'meeting',
                component: () => import('@/views/event/edit/meeting.vue'),
                meta: {
                    index: 3,
                    title: '添加会议室',
                    keepAlive: true,
                },
            },
            {
                path: 'event/meeting/occupancy',
                name: 'occupancy',
                component: () => import('@/views/event/edit/occupancy.vue'),
                meta: {
                    index: 4,
                    title: '会议室占用情况',
                    keepAlive: true,
                },
            },
            {
                path: 'weekly',
                component: () => import('@/views/weekly/Weekly.vue'),
                meta: {
                    index: 1,
                    title: '周报',
                },
            },
            {
                path: 'week-preview',
                name: 'weekPreview',
                component: () => import('@/views/weekly/WeekPreview.vue'),
                meta: {
                    index: 2,
                    title: '周报预览',
                },
            },
            {
                path: 'historyWeekly',
                name: 'historyWeekly',
                component: () => import('@/views/weekly/Weeklydetails.vue'),
                meta: {
                    index: 2,
                    title: '历史周报',
                },
            },
            {
                path: 'weeklydetails',
                component: () => import('@/views/weekly/Weeklydetails.vue'),
                meta: {
                    index: 2,
                    title: '周报',
                },
            },
            {
                path: 'setting',
                component: () => import('@/views/setting.vue'),
                meta: {
                    index: 2,
                    title: '周报设置',
                },
            },
            // 团队日历
            {
                path: 'team-calendar',
                component: () => import('@/views/team/index.vue'),
                meta: {
                    index: 1,
                    title: '团队日历',
                    keepAlive: true,
                },
            },
            {
                path: 'team-calendar/member',
                name: 'teamMember',
                component: () => import('@/views/team/member.vue'),
                meta: {
                    index: 2,
                    title: '团队成员',
                    keepAlive: true,
                },
            },
            // 关注日历
            // {
            //     path: 'my-follow',
            //     name: 'myFollow',
            //     component: () => import('@/views/concern/calendar.vue'),
            //     meta: {
            //         index: 1,
            //         title: '我的关注',
            //         keepAlive: true,
            //     },
            // },
            {
                path: 'my-follow/member',
                name: 'followMember',
                component: () => import('@/views/concern/member.vue'),
                meta: {
                    index: 2,
                    title: '管理关注人',
                    keepAlive: true,
                },
            },
            {
                path: 'under-construction',
                component: () => import('@/views/UnderConstruction.vue'),
                meta: {
                    index: 1,
                    title: '建设中',
                },
            },
        ],
    },
    // 单页面消息
    {
        path: '/weekly/report',
        beforeEnter: Login,
        component: () => import('@/views/weekly/Report.vue'),
        meta: {
            title: '数据概览',
        },
    },
    {
        path: '/followedInfo/:UserGUID',
        beforeEnter: Login,
        component: Followed,
        meta: {
            title: '日历消息提醒',
        },
    },
    {
        path: '/participant/:messageId',
        beforeEnter: Login,
        component: Participant,
        meta: {
            title: '日历消息提醒',
        },
    },
    {
        path: '/task-message/:TaskGUID',
        beforeEnter: Login,
        component: TaskMessage,
        meta: {
            title: '任务消息提醒',
        },
    },
    {
        path: '/task-message/notfound',
        name: 'notfound',
        beforeEnter: Login,
        component: Notfound,
        meta: {
            title: '任务消息提醒',
        },
    },
    authRouter(),
];

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0,
                left: 0,
                top: 0,
            };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title as any;
    }
    next();
});

export default router;
